import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ 'filter', 'tab' ];

	connect() {

    }

    toggle(e) {
		e.preventDefault();
        
        this.tabTargets.forEach( (tab) => {
            if(tab.dataset.key == e.target.dataset.key) {
                if(tab.classList.contains('hidden')) {
                    tab.classList.remove('hidden');
                    tab.classList.remove('lg:hidden');
                    e.target.classList.add('current');
                } else {
                    tab.classList.add('hidden')
                    tab.classList.add('lg:hidden')
                    e.target.classList.remove('current');
                }
            }
        });
    }

	switch(e) {
		e.preventDefault();
        
        this.resetCurrent();

        this.tabTargets.forEach( (tab) => {
            if(tab.dataset.key == e.target.dataset.key) {
                tab.classList.remove('hidden');
                tab.classList.remove('lg:hidden');
            }
        });

        e.target.classList.add('current');
	}

    resetCurrent() {
        this.tabTargets.forEach( (tab) => {
            if(!tab.classList.contains('hidden')) {
                tab.classList.add('hidden');
            }
            if(!tab.classList.contains('lg:hidden')) {
                tab.classList.add('lg:hidden');
            }
        });

        this.filterTargets.forEach( (filter) => {
            if(filter.classList.contains('current')) {
                filter.classList.remove('current');
            }
        });
    }
}